import { useEffect } from 'react';

/**
 * Attaches keyboard handlers for a fullscreen image viewer.
 * Also freezes body scroll while the viewer is open.
 */
export const useLightboxKeyboard = ({ onClose, onNext, onPrev, onZoomIn, onZoomOut, onReset }) => {
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowRight') onNext();
      else if (e.key === 'ArrowLeft') onPrev();
      else if (e.key === '+' || e.key === '=') onZoomIn();
      else if (e.key === '-' || e.key === '_') onZoomOut();
      else if (e.key === '0') onReset();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose, onNext, onPrev, onZoomIn, onZoomOut, onReset]);
};

export default useLightboxKeyboard;
